<!-- クーポンコード認証失敗 使用済み -->
<template>
  <ItemDialog ref="usedCouponCode" imageType="alert">
    <template v-slot:content-area>
      <h2>
        {{ $t("MyTicketTicketing.couponCodeFailed.title") }}
      </h2>
      <p class="text-center">すでに使用されたクーポンコードです。</p>
    </template>
    <template v-slot:button-area>
      <ItemButton
        label="戻る"
        actionType="btn-primary"
        @clicked="closeDialog"
      />
    </template>
  </ItemDialog>
</template>

<script>
export default {
  name: "DialogUsedCouponCode",
  methods: {
    async openDialog() {
      this.$refs.usedCouponCode.open();
    },
    async closeDialog() {
      this.$refs.usedCouponCode.close();
    },
  },
};
</script>
